var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('DashboardSlider'),_c('UploadProductSectionWidget'),_c('TrendingSection'),_c('SellHistoryAnalytics'),_c('TopSellerTopBuyerSliderSection'),_c('ProductTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }